export default __webpack_public_path__ + "static/media/16.3a1402b2.jpg";